import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from "react-router-dom";
import { getToken } from "../../helpers/auth";
import { LOGIN_PATH } from "../../constants/auth";
import Authorize from "../Authorize";
import DeniedPage from "../../pages/errors/DeniedPage";
import { PermissionType, RoleType } from "../../constants/authorize";

interface Props {
  path: string;
  authorizeByPermission?: PermissionType;
  authorizeByRole?: RoleType;
  renderComponent:
    | React.ComponentType<RouteComponentProps>
    | React.ComponentType;
}

const PrivateRoute: React.FC<Props & RouteProps> = ({
  path,
  authorizeByPermission,
  authorizeByRole,
  renderComponent: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props: RouteComponentProps) => {
      if (getToken()) {
        return (
          <Authorize
            permission={authorizeByPermission}
            role={authorizeByRole}
            deniedComponent={<DeniedPage />}
          >
            <Component {...props} />
          </Authorize>
        );
      }

      return <Redirect to={{ pathname: LOGIN_PATH, state: { from: path } }} />;
    }}
  />
);

export default PrivateRoute;
